import React, { useEffect, useState } from 'react';
import { getAdminProfile } from '../services/adminApi';
import { getAdminSession } from '../services/adminAuth';

export default function SettingsPage() {
  const session = getAdminSession() || {};
  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    getAdminProfile()
      .then((data) => setProfile(data.admin_info || data))
      .catch(() => setProfile(null))
      .finally(() => setProfileLoading(false));
  }, []);

  const displayName = profile?.name || session.user || 'Admin';
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div className="admin-page">
      <div className="admin-page__head">
        <div>
          <h1 className="admin-page__title">Settings</h1>
          <p className="admin-page__sub">Admin panel configuration and profile</p>
        </div>
      </div>

      {/* Admin Profile */}
      <div className="admin-panel" style={{ marginBottom: 24 }}>
        <div className="admin-panel__head">
          <p className="admin-panel__title">Admin Profile</p>
        </div>
        {profileLoading ? (
          <div className="admin-loading">
            <span className="admin-spinner admin-spinner--dark" />
            Loading profile…
          </div>
        ) : (
          <>
            <div className="admin-profile-card">
              <div className="admin-profile-card__avatar">{initial}</div>
              <div>
                <div className="admin-profile-card__name">{displayName}</div>
                <div className="admin-profile-card__role">
                  {profile?.user_type || 'Administrator'}
                </div>
              </div>
            </div>
            {profile && (
              <>
                {profile.email && (
                  <div className="admin-settings-row">
                    <span className="admin-settings-row__label">Email</span>
                    <span className="admin-settings-row__value">{profile.email}</span>
                  </div>
                )}
                {profile.username && (
                  <div className="admin-settings-row">
                    <span className="admin-settings-row__label">Username</span>
                    <span className="admin-settings-row__value">{profile.username}</span>
                  </div>
                )}
                {profile.phone && (
                  <div className="admin-settings-row">
                    <span className="admin-settings-row__label">Phone</span>
                    <span className="admin-settings-row__value">{profile.phone}</span>
                  </div>
                )}
                {profile.status && (
                  <div className="admin-settings-row">
                    <span className="admin-settings-row__label">Account Status</span>
                    <span className={`admin-badge admin-badge--${profile.status === 'active' ? 'active' : 'inactive'}`}>
                      {profile.status}
                    </span>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>

      {/* Environment Config */}
      <div className="admin-panel">
        <div className="admin-panel__head">
          <p className="admin-panel__title">Configuration</p>
        </div>

        <div className="admin-settings-row">
          <span className="admin-settings-row__label">API Base URL</span>
          <span className="admin-mono">
            {process.env.REACT_APP_AUTH_API_BASE_URL ||
              process.env.REACT_APP_API_BASE_URL ||
              'https://apidev.chemrobotics.com'}
          </span>
        </div>
        <div className="admin-settings-row">
          <span className="admin-settings-row__label">Platform</span>
          <span className="admin-mono">{process.env.REACT_APP_CHEMROBOTICS_PLATFORM || 'PharmVetPat'}</span>
        </div>
        <div className="admin-settings-row">
          <span className="admin-settings-row__label">Chatbot App</span>
          <a href="/" target="_blank" rel="noopener noreferrer">
            Open Chatbot →
          </a>
        </div>
        <div className="admin-settings-row">
          <span className="admin-settings-row__label">Admin Login</span>
          <span className="admin-mono">/admin</span>
        </div>
        <div className="admin-settings-row">
          <span className="admin-settings-row__label">Session Storage</span>
          <span className="admin-settings-row__value">Browser sessionStorage (cleared on tab close)</span>
        </div>
        <div className="admin-settings-note">
          Override environment variables in your <code>.env</code> file:{' '}
          <code>REACT_APP_API_BASE_URL</code>, <code>REACT_APP_CHEMROBOTICS_API_KEY</code>,{' '}
          <code>REACT_APP_CHEMROBOTICS_PLATFORM</code>.
        </div>
      </div>
    </div>
  );
}
